export const iconFontAwesomeMedicalHealthFlask = (
	<i className="fa-solid fa-flask"></i>
);
